export type AppFlavor = 'box' | 'saas' | 'dev'

declare const __APP_FLAVOR__: AppFlavor

/** Compile-time flavor from Vite mode; dev mode falls back to VITE_SAAS. */
export function isSaasApp(): boolean {
  if (__APP_FLAVOR__ === 'saas') return true
  if (__APP_FLAVOR__ === 'box') return false
  return import.meta.env.VITE_SAAS === 'true'
}

export function appFlavor(): AppFlavor {
  if (__APP_FLAVOR__ !== 'dev') return __APP_FLAVOR__
  return import.meta.env.VITE_SAAS === 'true' ? 'saas' : 'box'
}
